import { BannerType } from 'types/banner.types';
import { resizeImageByURL } from 'utils/image-file';
import { useIsScreenSizeMin } from 'utils/screen-size';

import config from '../../config';
import Banner from './Banner';

const useWebp = config.get('web.useWebpImages');

type Props = {
  banner: BannerType;
};

const BannerContainer = (props: Props) => {
  const { banner } = props;

  const isLargeDesktop = useIsScreenSizeMin('lg') && 's2000'; // 1200px screen width, 2000 is the most image resizer gives out
  const isDesktop = useIsScreenSizeMin('md') && !isLargeDesktop && 's1600'; // 900px screen width
  const isTablet = useIsScreenSizeMin('sm') && !isDesktop && !isLargeDesktop && 's1300'; //600px screen width
  const isMobile = useIsScreenSizeMin('xs') && !isTablet && !isDesktop && !isLargeDesktop && 's700c'; //0px screen width, image is squared
  const defaultSize = 's1600';

  const s3Image = banner?.imageURL?.includes('images.');

  const imageUrl = banner?.imageURL;
  const imageUrlMobile = banner?.mobileImageURL || banner?.imageURL;

  const imgUrl = isMobile ? imageUrlMobile : imageUrl;

  const webpSrc = resizeImageByURL(imgUrl, `${isLargeDesktop || isDesktop || isTablet || isMobile || defaultSize}-rw`, 's0');
  const jpgSrc = resizeImageByURL(imgUrl, isLargeDesktop || isDesktop || isTablet || isMobile || defaultSize, 's0');

  return <Banner link={banner?.link} useWebp={useWebp && s3Image} webpSrc={webpSrc} jpgSrc={jpgSrc} name={banner?.name} />;
};

export default BannerContainer;
